import React from "react";
import {
  ComingsoonContainer,
  ComingsoonWrapper,
  Rows,
  CardContainer,
  BuildTitle,
  BuildContent,
  BuildBtn,
  ContentWrapper,
  CardOverlay,
  CommingSoonLock,
} from "./style";

const Comingsoon = () => {
  return (
    <ComingsoonWrapper>
      <ComingsoonContainer>
        <Rows>
          <CardContainer
            bg={"assets/Comingsoon/1.png"}
            width={"55%"}
            data-aos="fade-right"
            data-aos-delay="1400"
          >
            <CardOverlay>
              <ContentWrapper>
                <BuildTitle>Turn Text into an Image </BuildTitle>
                <BuildContent>
                  Enter a description or keywords for the image you want to
                  generate
                </BuildContent>
                <BuildBtn>
                  <a
                    href="https://app.stellartai.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Start Building
                  </a>
                </BuildBtn>
              </ContentWrapper>
            </CardOverlay>
          </CardContainer>
          <CardContainer
            bg={"assets/Comingsoon/mint.png"}
            width="45%"
            data-aos="fade-left"
            data-aos-delay="1600"
          >
            <CardOverlay>
              <ContentWrapper>
                <BuildTitle>Turn Image into an NFT</BuildTitle>
                <BuildContent>
                  Mint your digital artwork by converting the image into a
                  unique, blockchain-based non-fungible token (NFT)
                </BuildContent>
                <BuildBtn>
                  <a
                    href="https://app.stellartai.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Start Minting
                  </a>
                </BuildBtn>
              </ContentWrapper>
            </CardOverlay>
          </CardContainer>
        </Rows>
        <Rows>
          <CardContainer
            bg={"assets/Comingsoon/come.png"}
            width={"45%"}
            data-aos="fade-up"
            data-aos-delay="1600"
          >
            <CardOverlay>
              <ContentWrapper>
                <BuildTitle>Turn Text into a Video</BuildTitle>
                <BuildContent>
                  Provide a script, storyboard, or outline for the video you
                  want to create
                </BuildContent>
                <BuildBtn>GET STARTED</BuildBtn>
              </ContentWrapper>
            </CardOverlay>
            <CommingSoonLock>
              <img src="/assets/Comingsoon/coming.png" alt="" />
            </CommingSoonLock>
          </CardContainer>
          <CardContainer
            bg={"assets/Comingsoon/come.png"}
            width="45%"
            data-aos="fade-up"
            data-aos-delay="1900"
          >
            <CardOverlay>
              <ContentWrapper>
                <BuildTitle>Turn Image into an Image</BuildTitle>
                <BuildContent>
                  Upload or draw an image to use as inspiration
                </BuildContent>
                <BuildBtn>GET STARTED</BuildBtn>
              </ContentWrapper>
            </CardOverlay>
            <CommingSoonLock>
              <img src="/assets/Comingsoon/coming.png" alt="" />
            </CommingSoonLock>
          </CardContainer>
          <CardContainer
            bg={"assets/Comingsoon/come.png"}
            width="45%"
            data-aos="fade-up"
            data-aos-delay="2200"
          >
            <CardOverlay>
              <ContentWrapper>
                <BuildTitle>Turn Image into an Image</BuildTitle>
                <BuildContent>
                  Upload or draw an image to use as inspiration
                </BuildContent>
                <BuildBtn>GET STARTED</BuildBtn>
              </ContentWrapper>
            </CardOverlay>
            <CommingSoonLock>
              <img src="/assets/Comingsoon/coming.png" alt="" />
            </CommingSoonLock>
          </CardContainer>
        </Rows>
      </ComingsoonContainer>
    </ComingsoonWrapper>
  );
};

export default Comingsoon;
